var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ASocialMediaAuthButton',{staticClass:"fa-github",attrs:{"icon":['fab', 'github'],"size":"lg","name":"Github","service":"github"}})}
var staticRenderFns = []

export { render, staticRenderFns }